'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import useEmblaCarousel from 'embla-carousel-react';
import { useParams } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';
import { buildGiftHeroImageUrl } from '@/app/_components/GiftCard/giftImage';
import { getGiftPreviewSnapshot, matchGiftPreview } from '@/app/_components/GiftCard/giftPreview';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { ThumbnailBackedImage } from './ThumbnailBackedImage';
interface HeroImageProps {
  heroImageUrlList: string[];
  adultYN: boolean;
}
export const HeroImage = t0 => {
  const $ = _c(33);
  const {
    heroImageUrlList,
    adultYN
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const params = useParams();
  let t1;
  if ($[0] !== params?.productNumber) {
    t1 = () => matchGiftPreview(getGiftPreviewSnapshot(), params?.productNumber)?.thumbnailSrc;
    $[0] = params?.productNumber;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [entryThumbnail] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      loop: true,
      align: "start"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t2);
  let t3;
  if ($[3] !== emblaApi) {
    t3 = () => {
      if (!emblaApi) {
        return;
      }
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };
    $[3] = emblaApi;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onSelect = t3;
  let t4;
  let t5;
  if ($[5] !== emblaApi || $[6] !== onSelect) {
    t4 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect();
      emblaApi.on("select", onSelect);
      return () => {
        emblaApi.off("select", onSelect);
      };
    };
    t5 = [emblaApi, onSelect];
    $[5] = emblaApi;
    $[6] = onSelect;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  const nextIndex = (selectedIndex + 1) % heroImageUrlList.length;
  let t6;
  if ($[9] !== adultYN || $[10] !== entryThumbnail || $[11] !== heroImageUrlList || $[12] !== isDesktopViewport || $[13] !== nextIndex || $[14] !== selectedIndex) {
    let t7;
    if ($[16] !== adultYN || $[17] !== entryThumbnail || $[18] !== isDesktopViewport || $[19] !== nextIndex || $[20] !== selectedIndex) {
      t7 = (url, index) => <div key={index} className="relative aspect-square min-w-0 flex-[0_0_100%] bg-Gray-black/10">{!isDesktopViewport || index === 0 ? <ThumbnailBackedImage src={buildGiftHeroImageUrl(url)} alt={`답례품 이미지 ${index + 1}`} thumbnailSrc={index === 0 ? entryThumbnail : undefined} loading={index === selectedIndex || index === nextIndex ? "eager" : "lazy"} preload={index === 0} fetchPriority={index === 0 ? "high" : undefined} /> : <Skeleton className="absolute size-full" />}{adultYN && <div className="absolute left-20 top-20 rounded-xsmall bg-B-500 px-12 py-4 font-600 text-Gray-white typo-body4">19세이상 구매가능</div>}</div>;
      $[16] = adultYN;
      $[17] = entryThumbnail;
      $[18] = isDesktopViewport;
      $[19] = nextIndex;
      $[20] = selectedIndex;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    t6 = heroImageUrlList.map(t7);
    $[9] = adultYN;
    $[10] = entryThumbnail;
    $[11] = heroImageUrlList;
    $[12] = isDesktopViewport;
    $[13] = nextIndex;
    $[14] = selectedIndex;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[22] !== t6) {
    t7 = <div className="flex">{t6}</div>;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== emblaRef || $[25] !== t7) {
    t8 = <div className="overflow-hidden" ref={emblaRef}>{t7}</div>;
    $[24] = emblaRef;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== heroImageUrlList.length || $[28] !== selectedIndex) {
    t9 = heroImageUrlList.length > 1 && <div className="absolute inset-x-0 bottom-32 mx-auto w-fit rounded-pill bg-Gray-black/20 px-8 py-2 font-600 text-Gray-white typo-caption2">{selectedIndex + 1} / {heroImageUrlList.length}</div>;
    $[27] = heroImageUrlList.length;
    $[28] = selectedIndex;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t8 || $[31] !== t9) {
    t10 = <div className="relative w-full">{t8}{t9}</div>;
    $[30] = t8;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  return t10;
};